// src/utils/drawFunctions.js

/*
the sizing can be a little confusing because the view is isometric
a "full tile" length if drawn on the normal x axis will span the width of a tile's left and right corners
a "full tile" length if drawn on the normal y axis will span the height of a 2 tile's bottom and top corners

- you have to cut everything in half on the x
- you have to cut everything in quarters on the y axis
- so if you want to draw a 1 x 1 sqaure, it will be done in halfs on the x, and quaters on the y

drawing order

1. move to the bottom midle of the selected tile
2. draw bottom left edge: \
3. draw top left edge: /
4. draw top right edge \
5. close the share (draws bottom left edge): /
then you get something like

const oneEdgeX = (tileSize / 2) * zoom;
const oneEdgeY = (tileSize / 4) * zoom;

// draw the "square" on the isometric grid

  /*  context.beginPath();
   context.moveTo(x, y + oneEdgeY * size - gap); // set context to bottom middle corner
   context.lineTo(x - oneEdgeX * size + gap, y); // draw to left corner
   context.lineTo(x, ); // draw to top middle corner
   context.lineTo(x + oneEdgeX * size - gap, y); // draw to left corner
   context.closePath(); // close off the tile
   
   context.fillStyle = "rgba(255, 0, 0, 0.5)"; // Fill color with transparency
   context.fill();
   context.strokeStyle = 'red';
   context.lineWidth = 2;
   context.stroke(); */

// Draw the commander's name in the center of the city
/* context.fillStyle = 'black';
context.font = `${12 * zoom}px Arial`;
context.textAlign = 'center';
context.textBaseline = 'middle';
context.fillText(commander, x, y);

/\
\/
*/

import tileInformation from "./tileInformation.json"

export const drawBaseTile = (context, x, y, type, tileSize, zoom, gap, coordX, coordY) => {
  const halfTileSize = (tileSize / 2) * zoom;
  const quarterTileSize = (tileSize / 4) * zoom;
  context.beginPath();
  context.moveTo(x, y + halfTileSize - gap);
  context.lineTo(x - halfTileSize + gap * 2, y + quarterTileSize);
  context.lineTo(x, y + gap);
  context.lineTo(x + halfTileSize - gap * 2, y + quarterTileSize);
  context.closePath();
  // Draw the coordinates in the center of the tile

  // Handle the "navigateHighlight" type
  if (type === "navigateHighlight") {
    context.strokeStyle = "red"; // Set highlight color
    context.lineWidth = 6; // Thicker outline
    context.stroke();
    return; // Exit function after drawing the highlight
  }

  if (type === "grid") {
    context.strokeStyle = "green";
    context.lineWidth = 2;
    context.stroke();
    context.font = `${6 * zoom}px Arial`;
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    context.fillText(`${coordX}, ${coordY}`, x, y + quarterTileSize);
  } else {
    context.strokeStyle = "black";
    context.lineWidth = 2;
    context.stroke();
    context.fillStyle = "rgba(0, 0, 0, 0.8)"; // Fill color with transparency
    context.fill();
  }
  return
};

export const drawTileOutline = (
  context,
  x,
  y,
  size,
  tileSize,
  zoom,
  gap,
  strokeStyle = '#ff3333',
  lineWidth = 4
) => {
  const halfTileSize = (tileSize / 2) * zoom;
  const quarterTileSize = (tileSize / 4) * zoom;

  context.beginPath();
  context.moveTo(x, y + halfTileSize * size - gap);
  context.lineTo(x - halfTileSize * size + gap * 2, y + quarterTileSize * size);
  context.lineTo(x, y - halfTileSize * (size - 1) + gap);
  context.lineTo(x + halfTileSize * size - gap * 2, y + quarterTileSize * size);
  context.closePath();
  context.strokeStyle = strokeStyle;
  context.lineWidth = lineWidth;
  context.stroke();
};

export const drawTile = (context, x, y, tile, tileSize, zoom, gap, loadedImages) => {
  // first we calculate the length of 1 "edge" in either direction based on the isometric view
  // in the drawing functions we will use this length multiplied by the size of that tile type
  // this will let us dynamically draw any size tile, and create new tile types
  // we just have to define the type and size of that tile in the /tileInformation.json file

  const level = tile.additionalTileInfo?.level
  const name = tile.additionalTileInfo?.commander?.name
  const acronym = tile.additionalTileInfo?.alliance?.acronym
  const type = tile.type
  const tileInfo = tileInformation[type]
  const size = tileInfo.size
  const xCord = x - tileSize / 2 * size * zoom + gap
  const yCord = y - tileSize / 2 * (size - 1) * zoom + gap / 2

  const drawCenteredLabel = (text, centerY, options = {}) => {
    if (!text) return;

    const {
      fontSize = 8,
      minWidth = 0,
      paddingX = 5 * zoom,
      paddingY = 2 * zoom,
      background = 'white',
      foreground = 'black'
    } = options;

    const fontPx = Math.max(8, fontSize * zoom);
    context.font = `${fontPx}px Arial`;
    context.textAlign = 'center';
    context.textBaseline = 'middle';

    const measuredTextWidth = context.measureText(text).width;
    const boxWidth = Math.max(minWidth, measuredTextWidth + paddingX * 2);
    const boxHeight = fontPx + paddingY * 2;

    context.fillStyle = background;
    context.fillRect(x - boxWidth / 2, centerY - boxHeight / 2, boxWidth, boxHeight);

    context.fillStyle = foreground;
    context.fillText(text, x, centerY);
  };

  let img
  if (type === "flag" && loadedImages[type + "-" + acronym + '.png']) {
    img = loadedImages[type + "-" + acronym + '.png'];
  } else if (type === "benefit" && tile.additionalTileInfo) {
    img = loadedImages[tile.additionalTileInfo.benefitSubType + '.png'];
  } else {
    img = loadedImages[type + '.png'];
  }

  if (img) {
    context.drawImage(img, xCord + gap, yCord, tileSize * size * zoom - gap * 4, tileSize / 2 * size * zoom - gap);
    if (name) {
      drawCenteredLabel(name, y + tileSize / 4 * zoom);
    }
    if (level) {
      drawCenteredLabel(`Level: ${level}`, y + tileSize / 4 * zoom);
    }
    if (type === "flag" || type === "allianceHall") {
      drawCenteredLabel(`${acronym ? acronym : "UNKNOWN"}`, y + tileSize / 2.5 * zoom);
    }

  };
  return
};

export const drawTerritory = (context, x, y, tile, tileSize, zoom, gap) => {
  const typeMappings = {
    flag: { start: -1, end: 3 },
    allianceHall: { start: -5, end: 6 },
    fort: { start: -2, end: 3 },
  }

  const type = tile.type
  const bounds = typeMappings[type];
  if (!bounds) {
    return;
  }
  const { start, end } = bounds;
  let color = tile.additionalTileInfo?.alliance?.territoryColor
  if (!color) {
    color = "0,0,0"
  }

  const halfTileSize = (tileSize / 2) * zoom;
  const quarterTileSize = (tileSize / 4) * zoom;
  const span = end - start + 1;

  // Draw one territory polygon per source tile (flag/fort/hall) instead of one
  // polygon for every covered tile. This reduces draw calls heavily at all zoom levels.
  const topPoint = {
    x,
    y: y + (2 * (start - 1) * quarterTileSize) + gap,
  };
  const rightPoint = {
    x: x + span * halfTileSize - gap * 2,
    y: y + (start + end - 1) * quarterTileSize,
  };
  const bottomPoint = {
    x,
    y: y + 2 * end * quarterTileSize - gap,
  };
  const leftPoint = {
    x: x - span * halfTileSize + gap * 2,
    y: y + (start + end - 1) * quarterTileSize,
  };

  context.fillStyle = 'rgba(' + color + ', 0.2)'; // Territory fill color
  context.strokeStyle = 'rgb(' + color + ')';
  context.lineWidth = 1;

  context.beginPath();
  context.moveTo(bottomPoint.x, bottomPoint.y);
  context.lineTo(leftPoint.x, leftPoint.y);
  context.lineTo(topPoint.x, topPoint.y);
  context.lineTo(rightPoint.x, rightPoint.y);
  context.closePath();
  context.fill();
  context.stroke();
};
